import { useContext } from "react"
import { FilterContext } from "../Contexts/FilterContext/FilterContextProvider"
import { FilterContextType } from "../Types/Filter/FilterContext.type";

export const useFilter = (): FilterContextType => {
    const context = useContext(FilterContext);
    if(!context){
        throw new Error('useFilter deve ser utilizando dentro um FilterContextProvider.');
    }
    return context;
}